import React from "react";
import moment from 'moment';
import { Layout, PageHeader, Space,  Table,  Radio, DatePicker, Divider, Button, Grid, Collapse, Typography, Empty } from "antd";
import { useState } from "react";
import { useEffect } from "react";
import Spinner from "../../../components/Layout/Spinner";
import DashboardService from "../../../services/DashboardService";
import RatingLayout from "../../../components/Layout/RatingLayout";
import RatingDetail from "./RatingDetails";
import { CloseCircleFilled, StarFilled } from "@ant-design/icons";
import PosPage from "./posPage";
import './style.scss';
const { Content } = Layout;
const { useBreakpoint } = Grid;
const { Title, Text } = Typography;
const { Panel } = Collapse;

const RatingDashboard = () => {
  const [isLoading, setLoading] = useState(false);
  const [singleItem, setSingleItem] = useState();
  const [showDetails, setShowDetails] = useState(false);
  const [fromDate, setFromDate] = useState(moment().startOf('day').format('DD-MM-YYYY'));
  const [toDate, setToDate] = useState(moment().endOf('day').format('DD-MM-YYYY'));
  const [size, setSize] = useState('day');
  const [type, setType] = useState('pos');
  const [data, setData] = useState({});
  const [showRatingTable, setShowRatingTable] = useState(false);
  const screens = useBreakpoint();


  const getOnlineRating = async () => {
    const res = await DashboardService.getonlineRating(fromDate, toDate);
    setLoading(false)
    setData(res);
  };
  const getPosRating = async () => {
    const res = await DashboardService.getPosRating(fromDate, toDate);
    setLoading(false)
    setData(res);
  };
  useEffect(()=>{
    setLoading(true)
    if(type === 'pos'){
      getPosRating();
    } else {
      getOnlineRating();
    }
  },[fromDate, toDate, type])

const getColor =(rating)=>{
    switch (rating){
            case 1 :
            return "#BD1B04"
            case 2 :
            return "#BD5204"
            case 3 :
            return "#D7C200"
            case 4 :
            return "#8DA400"
            case 5 :
            return "#0B8617"
            default :
            return "#0B8617"
    }
}
 
  const columns = [
    // {
    //   title: `Order No`,
    //   dataIndex: "orderId",
    //   key: "orderId",
    //   render: (_, record) => {
    //     return (
    //       <div className="flex justify-center" >
    //         <div  className="name_text">
    //           {record?.order?.order_num}
    //         </div>
    //       </div>
    //     );
    //   },
    // },
    {
      title: "Table No",
      dataIndex: "tableId",
      key: "tableId",
      render: (_, record) => {
        return (
          <div className="flex justify-center" >
            <div  className="name_text">
              {record?.order?.table_number || record?.order?.order_num}
            </div>
          </div>
        );
      },
    },
    {
        title: "Rating",
        dataIndex: "name",
        key: "name",
        render: (_, record) => {
          return (
            <div className="flex justify-center">
              <RatingLayout name="Taste" rating={record.taste_rating} color={getColor(record.taste_rating)}/>
              <RatingLayout name="Ambience" rating={record.ambience_rating} color={getColor(record.ambience_rating)}/>
              <RatingLayout name="Service" rating={record.service_rating} color={getColor(record.service_rating)}/>
              <RatingLayout name="Price" rating={record.pricing_rating} color={getColor(record.pricing_rating)}/>
            </div>
          );
        },
      },
      {
        title: "Feedback",
        dataIndex: "name",
        key: "name",
        render: (_, record) => {
          return (
            <div className="flex">
              <div  className="name_text">
                {record.review}
              </div>
            </div>
          );
        },
      }
  ];

  const numberOfStar=(number)=>{
    const stars = [];
    for(let i = 0; i< number ;i++)
      stars.push(i);
    return stars
  }
  const columnsRating = [
    {
      title: "Star Rating",
      dataIndex: "name",
      key: "name",
      render: (_, record) => {
        return (
          <div style={{ display: "flex" }} >
            {numberOfStar(record.taste_rating).map(item=>
            <div key={item} className="name_text">
             <StarFilled style={{color:getColor(parseInt(record.taste_rating))}}/>
            </div>
            )}
          </div>
        );
      },
    },
    {
      title: "Number of Reviews",
      dataIndex: "count",
      key: "count",
      width: 220,
      render: (_, record) => {
        return (
          <div style={{ display: "flex" }} >
            <div  className="name_text">
              {record.count}
            </div>
          </div>
        );
      },
    }]
 
  const showDetailsView=(value)=>{
    setShowDetails(value)
  }

  const showRatingView=(value)=>{
    setShowRatingTable(true)
  }
  const onFilterDateChange = (date, dateString, field) => {
    if(field === 'starDate'){
      setFromDate(moment(dateString, 'MMM DD, YYYY'));
    } else {
      setToDate(moment(dateString, 'MMM DD, YYYY'));
    }
    setSize('');
  };
  const onPeriodChange = (e) => {
    setSize(e.target.value);
    setFromDate(moment().startOf(e.target.value).format('DD-MM-YYYY'));
    setToDate(moment().endOf(e.target.value).format('DD-MM-YYYY'))
  };
  const onReset = () => {
    setSize('day');
    setFromDate(moment().startOf('day').format('DD-MM-YYYY'));
    setToDate(moment().endOf('day').format('DD-MM-YYYY'))
  };
  const filteredColumns = columns.filter((col) => {
    // Only include the "Age" column if hideAgeColumn is false
    if (col.key === "tableId" && type !== 'pos') {
      return false;
    }
    return true;
  });
  return (
    <Layout className="u-page-layout tips-layout">
       {showDetails?
        <RatingDetail order={singleItem} setShowDetails ={showDetailsView} showDetails={showDetails} type={type}/>:
        <Content className="w-full page-padding">
          <Space direction="vertical" style={{ width: "100%" }}>
            <Radio.Group value={type} onChange={(e) => setType(e.target.value)}>
                <Radio.Button value="pos" className="pos-radio-button">POS</Radio.Button>
                <Radio.Button value="online" className="online-radio-button">ONLINE</Radio.Button>
            </Radio.Group>
            <Divider/>
            <PageHeader
              title="Ratings"
              className="page-header"
              extra={[
                <>
                {/* <div className="flex" style={{ border: size ? "0px" : "2px solid red"}}>
                <div className=""><DatePicker name="starDate" allowClear={false} onChange={(date, dString)=>onFilterDateChange(date, dString, "starDate")} value={moment(fromDate, "DD-MM-YYYY")} format="MMM DD, YYYY" /></div>
                <div className=""><DatePicker name="endDate" allowClear={false} onChange={(date, dString)=>onFilterDateChange(date, dString, 'endDate')} value={moment(toDate, "DD-MM-YYYY")} format="MMM DD, YYYY" /></div>
                <Button type={size ? "dashed" : "primary" } onClick={onReset}>Reset</Button>
                </div> */}
                <div>
                <Radio.Group value={size} onChange={onPeriodChange}>
                <Radio.Button value="day" className="pos-radio-button">Daily</Radio.Button>
                <Radio.Button value="week">Weekly</Radio.Button>
                <Radio.Button value="month">Monthly</Radio.Button>
                <Radio.Button value="year" className="online-radio-button">Total</Radio.Button>
                </Radio.Group>
            </div>
            </>
              ]}
            />
            <PosPage data={data} showRatingView={showRatingView} type={type}/>
            {showRatingTable &&
            <div className="flex">
              <div className="relative" style={{display:"inline-block"}}>
                <Table
                  columns={columnsRating}
                  dataSource={data?.taste_star_rating}
                  pagination={false}
                  style={{width: screens.md ? "500px" : "100%"}}
                  className="discount-table waitlist-table"
                />
                <div className="table_close_Icon">
                  <CloseCircleFilled onClick={()=> setShowRatingTable(false)}/>
                </div>
              </div>
              </div>
            }
          <Divider/>
          <PageHeader
              title="Reviews"
              className="page-header"
              extra={[]}
            />
            {screens.md ?
            <Table
              columns={filteredColumns}
              dataSource={data?.ratings || []}
              className="discount-table rating_dashbrd overflow-auto"
              onRow={(record, rowIndex) => {
                return {
                  onClick: (event) => {
                    setSingleItem(record);
                    setShowDetails(type)
                  }
                }; 
              }}
            /> 
            :
            <div>
             {data?.ratings?.length === 0 ?
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                :
             data?.ratings?.map((record) => (
              <Collapse
  bordered={false}
  defaultActiveKey={[screens.md ?"issues" :""]}
  expandIconPosition="end"
  className="review-list-collapse"
>
   <Panel
    key="issues"
    header={
      <div className="flex" >
            <div  className="name_text">
             Table no- {record?.order?.table_number || record?.order?.order_num}
            </div>
          </div>
    }
  >
    <div className="flex flex-wrap">
              <RatingLayout name="Taste" rating={record.taste_rating} color={getColor(record.taste_rating)}/>
              <RatingLayout name="Ambience" rating={record.ambience_rating} color={getColor(record.ambience_rating)}/>
              <RatingLayout name="Service" rating={record.service_rating} color={getColor(record.service_rating)}/>
              <RatingLayout name="Price" rating={record.pricing_rating} color={getColor(record.pricing_rating)}/>
            </div>

            <div className="feedback-collapse">
             <span>Feedback: </span> &nbsp;<span>{ record.review}</span>
            </div>

  </Panel>
</Collapse>
      
    ))}
    </div>
            }
          <Divider/>
        </Space>
        </Content>
      }
    {isLoading && <Spinner/>}
    </Layout>
  );
};

export default RatingDashboard;
